import {createSlice, createAsyncThunk,
	PayloadAction}							from '@reduxjs/toolkit';
import * as Sentry							from '@sentry/browser';

import {RootState}							from '../../app/store';
import {UserState}							from './interface';
import {PutUserData}						from '../companyUsers/interface';
import actions 								from './userAction';

import {setLocalStorage}					from '../../ressources/functions/localStorage';


const initialState: UserState = {
	isAuthenticated: false,
	data:            null,
	error:           null,
	isLoad:          false,
	reload:          0
};

export const login = createAsyncThunk('user/login', actions.login);
export const checkIsConnected = createAsyncThunk('user/checkIsConnected', actions.checkIsConnected);
export const switchUserCompany = createAsyncThunk('user/switchUserCompany', actions.switchUserCompany);

export const Reducer = createSlice({
	name:     'user',
	initialState,
	reducers: {
		logout: (state) => {
			setLocalStorage('user', '');
			Sentry.setUser(null);
			state.isAuthenticated = false;
			state.data = null;
			state.error = null;
			state.reload = 0;
		},
		clearError: (state) => {
			state.error = null;
		},
		changeUserSettings: (state, action: PayloadAction<PutUserData>) => {
			if (state.data) {
				state.data.firstname = action.payload.firstname as string;
				state.data.lastname = action.payload.lastname as string;
				state.data.email = action.payload.email as string;
				state.data.phone = action.payload.phone as string;
				state.data.contractStart = action.payload.contractStart?.toString() || '';
				state.data.contractEnd = action.payload.contractEnd?.toString() || '';
				state.data.job = action.payload.job as string;
			}
		},
		changeUserProfilePicture: (state, action: PayloadAction<string>) => {
			if (state.data)
				state.data.profilePicture = action.payload;
		},
		setUserMFA: (state) => {
			if (state.data?.data)
				state.data.data.mfa = true;
		}
	},
	extraReducers: (builder) => {
		builder
		.addCase(login.pending, (state) => {
			return ({...state, isLoad: true});
		})
		.addCase(login.fulfilled, (state, action) => {
			setLocalStorage('user', action.payload.data);
			return ({...state, isLoad: false, ...action.payload, reload: state.reload});
		})
		.addCase(checkIsConnected.fulfilled, (state, action) => {
			setLocalStorage('user', action.payload.data);
			return ({...state, ...action.payload, reload: state.reload});
		})
		.addCase(switchUserCompany.fulfilled, (state, action) => {
			setLocalStorage('user', action.payload.data);
			return ({
				...state,
				...action.payload,
				reload: state.reload + 1
			});
		});
	}
});

export const {logout, changeUserSettings, changeUserProfilePicture, setUserMFA, clearError} = Reducer.actions;

export const user = (state: RootState) => state.user.data;
export const isAuth = (state: RootState) => state.user.isAuthenticated;

export default Reducer.reducer;
